<p-dialog
  [modal]="true"
  [(visible)]="visible"
  [style]="{ width: '760px' }"
  [dismissableMask]="true"
  (onHide)="close()"
  (onShow)="onDialogShow()">
  <ng-template pTemplate="header">
    <div class="flex items-center gap-8 text-2xl font-[600] text-[var(--p-slate-900)]">
      @if (editing) {
      Edit skill
      } @else {
      Add skill
      }
    </div>
  </ng-template>

  <div class="flex flex-col gap-16">
    <label class="flex flex-col gap-6">
      <span class="text-sm font-semibold text-[var(--p-slate-800)]">Skill name</span>
      <input
        pInputText
        class="w-full"
        [(ngModel)]="name"
        name="skillName"
        maxlength="128"
        placeholder="weekly status report"
        autocomplete="off"
        [disabled]="saving()" />
    </label>

    <label class="flex flex-col gap-6">
      <span class="text-sm font-semibold text-[var(--p-slate-800)]">Description</span>
      <textarea
        pTextarea
        class="w-full"
        rows="2"
        [(ngModel)]="description"
        name="skillDescription"
        maxlength="512"
        placeholder="Generate weekly status reports from recent work."
        [disabled]="saving()"></textarea>
    </label>

    <div class="skill-md">
      <div class="skill-md__bar">
        <span>SKILL.md</span>
        @if (!editing) {
          <button type="button" class="skill-md__add" [disabled]="saving()" (click)="openFilePicker(skillFileInput)">
            + Add file
          </button>
        }
      </div>
      <div class="skill-md__sheet">
        @for (line of frontmatterLines; track $index) {
          <div class="skill-md__line">{{ line }}</div>
        }
        <textarea
          class="skill-md__editor"
          rows="10"
          [(ngModel)]="prompt"
          name="skillPrompt"
          maxlength="10000"
          [placeholder]="promptPlaceholder"
          [disabled]="saving()"></textarea>
      </div>
      <input
        #skillFileInput
        class="skill-file-input"
        type="file"
        accept=".md,text/markdown"
        (change)="onFileSelected($event)" />
    </div>

    <div class="flex flex-col gap-6">
      <div>
        <p-button
          label="Add parameter"
          size="small"
          severity="secondary"
          [disabled]="saving()"
          (onClick)="addParameter()" />
      </div>
      <span class="text-xs text-[var(--p-slate-500)]">{{ placeholderHint }}</span>
      @if (parameterNames.length) {
        <span class="text-xs text-[var(--p-slate-700)]">Asks for {{ parameterNames.join(', ') }}</span>
      }
    </div>

    @if (errorText()) {
      <p class="m-0 text-sm text-[var(--p-red-600)]">{{ errorText() }}</p>
    }
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-12">
      <p-button label="Cancel" severity="secondary" size="small" [disabled]="saving()" (onClick)="close()" />
      <p-button
        [label]="editing ? 'Save changes' : 'Create'"
        size="small"
        [disabled]="!canSave()"
        [loading]="saving()"
        (onClick)="save()" />
    </div>
  </ng-template>
</p-dialog>
